import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Card, message } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
// 3. Internal components
import CompanyFinanceBlock from "@/components/Company/CompanyFinanceBlock";
import CompanyRequisitesForm from "@/components/Company/CompanyRequisitesForm";
import CompanyStatusActions from "@/components/Company/CompanyStatusActions";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
// 5. Types, utils, styles
import { CompanyMapper } from "@/adapters/Company.mapper";
import { canManageCompanies, canManageSettlements } from "@/utils/permissions";
import styles from "@/styles/CompanyPage.module.less";
/**
 * Вкладка «Реквизиты и настройки» (P-3, UC1113). Реквизиты — обе роли (`canManageCompanies`);
 * финансовый блок и смена статуса — только ADMINISTRATOR (`canManageSettlements`, D14): у DISPATCHER
 * эти компоненты не монтируются и `v_corp_balances` не запрашивается.
 */
const SettingsTab = observer(() => {
    const { authStore, singleCompanyStore: store } = getRootStore();
    const company = store.company;
    const isFinanceAllowed = canManageSettlements(authStore.userRole);
    // Ссылка на компанию меняется только при перечитывании — форма не сбрасывает ввод на промежуточных рендерах.
    const initial = useMemo(() => (company ? CompanyMapper.requisitesOf(company) : null), [company]);
    if (!company)
        return null;
    const handleSubmit = async (requisites) => {
        const saved = await store.updateRequisites(requisites);
        if (saved)
            message.success("Реквизиты сохранены");
        return saved;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Card, { title: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B", className: styles.section, children: _jsx(CompanyRequisitesForm, { mode: "edit", initial: initial, canEdit: canManageCompanies(authStore.userRole), isSaving: store.isSaving, onSubmit: handleSubmit }) }), isFinanceAllowed ? _jsx(CompanyFinanceBlock, {}) : null, isFinanceAllowed ? _jsx(CompanyStatusActions, {}) : null] }));
});
SettingsTab.displayName = "SettingsTab";
export default SettingsTab;
